// extracted by mini-css-extract-plugin
export var cardIcon = "_5l-5";
export var cardIconUnframed = "_5l-9";
export var checkboxCard = "_5l-0";
export var checkboxCardSelected = "_5l-4";
export var disabled = "_5l-2";
export var interactive = "_5l-1";
export var outerBorder = "_5l-3";
export var spacerMedium = "_5l-8";
export var spacerSmall = "_5l-7";
export var spacerXsmall = "_5l-6";